/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./OnlineChat.vue?vue&type=template&id=33083367&scoped=true"
import script from "./OnlineChat.vue?vue&type=script&lang=js"
export * from "./OnlineChat.vue?vue&type=script&lang=js"
import style0 from "./OnlineChat.vue?vue&type=style&index=0&id=33083367&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33083367",
  null
  
)

export default component.exports